module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./TaskDetailView.js"));
	}, "TaskDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=TaskDetailView!./src/pages/Promote/Schedule/TaskDetail/TaskDetailView.js
// module id = 2098
// module chunks = 367